import React from 'react';


const Projects =()=>{
    return(
        <React.Fragment>
        <h1 style={{textAlign:'center', fontSize: '30px', marginBottom: '15px', paddingTop: "10px", fontWeight: 'bold'}}>Projects</h1>


        <h3 style={{textAlign:'center', fontSize: '20px', marginBottom: '30px', fontWeight: 'bold'}}>Coming Soon <span role="img" aria-label="emoji">😪😪😪😪😪😪</span> But you can always check <a href="https://github.com/Midetech">Here</a> </h3>
        </React.Fragment>
    )
}


export default Projects;
